import { useEffect } from 'react';

const SEO = ({ title, description, keywords, path = '' }) => {
  const siteName = "Dr. Venkata Pradeep Babu Koyyala";
  const fullTitle = title ? title + " | " + siteName : siteName + " | Medical Oncologist | Tezpur, Assam";
  const defaultDesc = "Leading Medical Oncologist in Tezpur, Assam. EC Member ISMPO, Executive Secretary NESMO. Expert in chemotherapy, immunotherapy, targeted therapy. Book consultation today.";

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name, content, property) => {
      if (!content) return;
      const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        if (property) el.setAttribute('property', name);
        else el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const desc = description || defaultDesc;
    setMeta('description', desc);
    if (keywords) setMeta('keywords', keywords);
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', desc, true);
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', desc);

    if (path) {
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', 'https://drvenkatapradeepbabukoyyala.com' + path);
    }
  }, [fullTitle, description, keywords, path]);

  return null;
};

export default SEO;
